<template>
<!--  <div class="badge__wrapper">-->
    <span v-if="count" class="badge__unread-messages">
      {{ printCount }}
    </span>
<!--  </div>-->
</template>
<script>

import { computed } from 'vue';

export default {
  props: ['count'],
  setup(props) {
    const printCount = computed(() => {
      if(props.count > 9) {
        return '9+'
      } else {
        return props.count
      }
    });

    return {
      printCount
    }
  },
}
</script>
<style lang="scss" scoped>

  .badge {

    //&__wrapper { }

    &__unread-messages {
      position: absolute;
      z-index: 1;
      font-size: 0.75rem;
      font-weight: 600;
      background-color: $badge-background-color;
      border: solid 1px white;
      color: white;
      width: 15px;
      height: 15px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
    }
  }
</style>
